import React, { useMemo } from 'react';
import { Box, Button, Text } from '@primer/react';

interface KetQuaThiSummaryProps {
  dsThiSinhs: any[];
  listDanhGias: any[];
  filter: number[];
  onFilterChanged: (ids: number[]) => void;
}

const KetQuaThiSummary: React.FC<KetQuaThiSummaryProps> = ({
  dsThiSinhs,
  listDanhGias,
  filter,
  onFilterChanged
}) => {
  const dataSource = useMemo(() => {
    if (listDanhGias && dsThiSinhs) {
      return listDanhGias.map((tt) => ({
        ...tt,
        so_luong: dsThiSinhs.filter((x) => x.ex_trangthai_thisinh_id === tt.id).length
      }));
    }
    return [];
  }, [dsThiSinhs, listDanhGias]);

  const handleChangeFilter = (ex_trangthai_thisinh_id: number) => {
    const new_ids = [...filter];
    const index = new_ids.indexOf(ex_trangthai_thisinh_id);
    if (index === -1) {
      new_ids.push(ex_trangthai_thisinh_id);
    } else {
      new_ids.splice(index, 1);
    }
    onFilterChanged(new_ids);
  };

  const FilterButton = ({ 
    isActive, 
    label, 
    count, 
    onClick 
  }: { 
    isActive: boolean; 
    label: string; 
    count: number; 
    onClick: () => void; 
  }) => (
    <Button
      onClick={onClick}
      variant={isActive ? "primary" : "default"}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: '28px',
        px: 2,
        py: 0,
        fontSize: '12px',
        borderRadius: '14px',
        gap: 1,
        fontWeight: isActive ? 'bold' : 'normal',
        whiteSpace: 'nowrap',
        minWidth: 'fit-content'
      }}
    >
      {label}
      {count > 0 && (
        <Box
          as="span"
          sx={{
            bg: isActive ? 'btn.primary.counterBg' : 'neutral.muted',
            color: isActive ? 'btn.primary.text' : 'fg.default',
            px: '6px',
            borderRadius: '10px',
            fontSize: '11px',
            lineHeight: '18px',
            display: 'inline-block'
          }}
        >
          {count}
        </Box>
      )}
    </Button>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        py: 1,
        px: 2
      }}
    >
      <FilterButton
        isActive={filter.length === 0}
        label="Tất cả"
        count={dsThiSinhs.length}
        onClick={() => onFilterChanged([])}
      />

      {dataSource.map((item, idx) => (
        <FilterButton
          key={idx}
          isActive={filter.includes(item.id)}
          label={item.ten_trangthai}
          count={item.so_luong}
          onClick={() => handleChangeFilter(item.id)}
        />
      ))}
    </Box>
  );
};

export default KetQuaThiSummary;